import { render, staticRenderFns } from "./VimeoVideoPlayer.vue?vue&type=template&id=110e1f4b&scoped=true&"
import script from "./VimeoVideoPlayer.vue?vue&type=script&lang=js&"
export * from "./VimeoVideoPlayer.vue?vue&type=script&lang=js&"
import style0 from "./VimeoVideoPlayer.vue?vue&type=style&index=0&id=110e1f4b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "110e1f4b",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AppImage: require('/vercel/path0/components/general/AppImage.vue').default})
